/**
 * ホームページ
 */
import React, { useState, useEffect } from 'react';
import styles from './Home.module.css';
import headerBg from '../../assets/images/武蔵野大学.jpg';
import bohLogo from '../../assets/images/Boh.jpg';
import { Link } from 'react-router-dom';


// ★ Swiperの読み込みを追加！
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination , Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';


function Home() {
  const [topNewsData, setTopNewsData] = useState([]);
  const [worksData, setWorksData] = useState([]);
  const [newsLoading, setNewsLoading] = useState(true);
  const [worksLoading, setWorksLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || 'https://bohpj-website.onrender.com'}/api/news`)
      .then(res => res.json())
      .then(data => {
        const actualData = Array.isArray(data) ? data : (data.items || []);
        setTopNewsData(actualData);
      })
      .catch(error => {
        console.error("通信エラー:", error);
        setTopNewsData([]);
      })
      .finally(() => setNewsLoading(false));

    fetch(`${process.env.REACT_APP_API_URL || 'https://bohpj-website.onrender.com'}/api/works?limit=5`)
      .then(res => {
        if (!res.ok) throw new Error('データの取得に失敗しました');
        return res.json();
      })
      .then(data => {
        const actualData = Array.isArray(data) ? data : (data.items || []);
        setWorksData(actualData);
      })
      .catch(error => {
        console.error("通信エラー:", error);
        setWorksData([]);
      })
      .finally(() => setWorksLoading(false));
  }, []);
  return (
    <div className={styles.container}>
      <header className={styles.homeHeader}>
        <img 
          src={headerBg} 
          alt="武蔵野大学" 
          className={styles.headerImage} 
        />
        
        <div className={styles.logoWrapper}>
          <img 
            src={bohLogo} 
            alt="Boh Logo" 
            className={styles.bohLogo} 
          />
          <span className={styles.logoText}>BohPJ</span>
        </div>
      </header>

      {/* NewsSection */}
      <section className={styles.newsSection}>
        <h2 className={styles.nsTitle}>News</h2>
        <div className={styles.nsContents}>
          <ul className={styles.nsList}>
            {newsLoading
              ? [1, 2, 3].map(i => (
                  <li key={i} className={styles.nsItem}>
                    <p className={`${styles.nsItemDate} ${styles.skeleton}`} style={{ width: 80, height: 16 }} />
                    <p className={`${styles.nsItemTitle} ${styles.skeleton}`} style={{ width: 280, height: 16 }} />
                  </li>
                ))
              : topNewsData.map((item) => (
                  <li key={item.id} className={styles.nsItem}>
                    <p className={styles.nsItemDate}>{item.date}</p>
                    <span className={styles.nsItemTitle}>{item.title}</span>
                  </li>
                ))
            }
          </ul>
          <Link to="/news" className={styles.moreButton}>
            more &gt;
          </Link>
        </div>
      </section>
      <section className={styles.aboutSection}>
        <div className={styles.aboutInner}>
          <div className={styles.aboutTextCol}>
            <h2 className={styles.aboutTitle}>About us</h2>
            <p className={styles.aboutDescription}>
              BohPJは研究・開発の実践を通じて学ぶことを目的とした団体です。
            </p>
            <p className={styles.aboutDescription}>
              オープンキャンパスへの出展をはじめ、学会発表やコンペティションへの参加など、対外的なアウトプットを行っています。授業だけでは得られない実践的な学びや経験を獲得することを目指し、活動に取り組んでいます。
            </p>
          </div>
          <div className={styles.aboutImageCol}>
            <img src={bohLogo} alt="BohPJ Logo" className={styles.aboutLogo} />
          </div>
        </div>
      </section>

      {/* ★ ここから WorksSection を追加！ */}
      <section className={styles.worksSection}>
        <div className={styles.worksHeader}>
          <h2 className={styles.worksTitle}>Works</h2>
        </div>

        <div className={styles.worksCarouselContainer}>
          <Swiper
            modules={[Pagination, Autoplay]}
            centeredSlides={true}
            pagination={{ clickable: true }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              0:   { slidesPerView: 1.2, spaceBetween: 16 },
              600: { slidesPerView: 1.8, spaceBetween: 28 },
              769: { slidesPerView: 2.5, spaceBetween: 40 },
            }}
            className={styles.mySwiper}
          >
            {worksLoading
              ? [1, 2, 3, 4, 5].map(i => (
                  <SwiperSlide key={i} className={styles.swiperSlideCustom}>
                    <div className={styles.worksItem}>
                      <div className={styles.worksItemContent}>
                        <p className={`${styles.skeleton}`} style={{ width: 100, height: 16, marginBottom: 8 }} />
                        <p className={`${styles.skeleton}`} style={{ width: '80%', height: 20, marginBottom: 8 }} />
                        <p className={`${styles.skeleton}`} style={{ width: 60, height: 24, borderRadius: 20 }} />
                      </div>
                      <div className={`${styles.worksItemImage} ${styles.skeleton}`} />
                    </div>
                  </SwiperSlide>
                ))
              : worksData.map((work) => (
                  <SwiperSlide key={work.id} className={styles.swiperSlideCustom}>
                    {/* TODO: 詳細ページ実装後に <Link to={`/works/${work.id}`}> に戻す */}
                    <div className={styles.worksItem}>
                      <div className={styles.worksItemContent}>
                        <p className={styles.worksItemDate}>{work.date}</p>
                        <h3 className={styles.worksItemTitle}>{work.title}</h3>
                        <div className={styles.worksItemLabels}>
                          {work.labels.map((label, index) => (
                            <span key={index} className={styles.worksItemLabel}>{label}</span>
                          ))}
                        </div>
                      </div>
                      <img
                        src={
                          (work.images && work.images.find(img => img.is_thumbnail)?.url)
                          || (work.images && work.images[0]?.url)
                          || work.imageUrl
                          || 'https://res.cloudinary.com/de301ufoq/image/upload/v1775915341/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-04-11_22.48.47_xo9nol.png'
                        }
                        alt={work.title}
                        className={styles.worksItemImage}
                      />
                    </div>
                  </SwiperSlide>
                ))
            }
          </Swiper>
        </div>


        {/* 右下の more > ボタン */}
        <div className={styles.worksMoreContainer}>
          <Link to="/works" className={styles.worksMoreButton}>
            more &gt;
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Home;